import { Store } from '@ngrx/store';
import { TrInputComponent } from './../tr-input/tr-input.component';
import { Component, ElementRef, Renderer2, ViewChild, Input } from '@angular/core';
import { AppState } from '../../../interfaces/app-state.interface';

@Component({
    selector: "tr-doc",
    templateUrl: "./tr-doc.component.html",
    styleUrls: ["./tr-doc.component.scss"],
})
export class TrDocComponent extends TrInputComponent {
    @Input() public onBlur?: () => Promise<void> | void;
    @ViewChild("formInput", { static: true }) public formInput: ElementRef;

    constructor(private render: Renderer2, store: Store<AppState>) {
        super(store);
    }

    public handleOnBlur() {
        if (this.onBlur) {
            this.onBlur();
        }

        this.registerOnTouched();
    }
}
